export default {
  title: 'Atributos dietéticos',
};
